/* ── Collection Catalog — all filters server-side via URL params ── */
(function () {
  'use strict';

  var elGrid, elEmpty, elCount, elPubSelect, elSortSelect;

  // ── Build a clean collection URL preserving requested params ───────────────
  function buildCollectionUrl(overrides) {
    var handle = (window.CC && window.CC.collectionHandle) || '';
    var url    = new URL('/collections/' + handle, window.location.origin);
    var cur    = new URL(window.location.href);

    // params to carry forward if not explicitly overridden
    var carry = ['sort_by', 'filter.p.tag', 'filter.p.vendor'];
    carry.forEach(function (key) {
      var val = (key in overrides) ? overrides[key] : cur.searchParams.get(key);
      if (val) url.searchParams.set(key, val);
    });
    return url.toString();
  }

  // ── Publisher dropdown ──────────────────────────────────────────────────────
  function buildPublisherDropdown() {
    var vendors      = (window.CC && window.CC.vendors)      || [];
    var activeVendor = (window.CC && window.CC.activeVendor) ||
                       new URL(window.location.href).searchParams.get('filter.p.vendor') || '';
    var html = '<option value="">All Publishers</option>';
    vendors.sort().forEach(function (v) {
      html += '<option value="' + v.replace(/"/g, '&quot;') + '"' +
              (activeVendor === v ? ' selected' : '') + '>' +
              v.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</option>';
    });
    elPubSelect.innerHTML = html;
  }

  // ── Count display ───────────────────────────────────────────────────────────
  function updateCount() {
    var total = typeof window.CC_FILTERED_TOTAL === 'number'
      ? window.CC_FILTERED_TOTAL
      : (typeof window.CC_TOTAL === 'number' ? window.CC_TOTAL : 0);
    elCount.textContent = total + ' products';
  }

  // ── Navigate helpers ────────────────────────────────────────────────────────
  function navigate(dest) {
    if (elGrid) elGrid.classList.add('cc-loading');
    window.location.href = dest;
  }

  function handleTypePillClick(tagValue, clickedBtn) {
    // Instant pill highlight before navigation
    document.querySelectorAll('.cc-type-pill').forEach(function (btn) {
      btn.classList.toggle('cc-type-pill--active', btn === clickedBtn);
    });
    navigate(buildCollectionUrl({
      'filter.p.tag':    tagValue && tagValue !== 'all' ? tagValue : '',
      'filter.p.vendor': new URL(window.location.href).searchParams.get('filter.p.vendor') || '',
      'page':            ''
    }));
  }

  function handlePublisherChange(val) {
    navigate(buildCollectionUrl({
      'filter.p.vendor': val,
      'page':            ''
    }));
  }

  function handleSortChange(val) {
    var url = new URL(window.location.href);
    if (val) { url.searchParams.set('sort_by', val); }
    else      { url.searchParams.delete('sort_by'); }
    url.searchParams.delete('page');
    navigate(url.toString());
  }

  // ── Init ────────────────────────────────────────────────────────────────────
  function init() {
    elGrid      = document.getElementById('cc-product-grid');
    elEmpty     = document.getElementById('cc-empty');
    elCount     = document.getElementById('cc-count');
    elPubSelect = document.getElementById('cc-pub-select');
    elSortSelect= document.getElementById('cc-sort-select');

    if (!elGrid) return;

    // Show empty state if server returned 0 results
    var allItems = elGrid.querySelectorAll('.cc-item');
    if (elEmpty) elEmpty.style.display = allItems.length === 0 ? '' : 'none';

    buildPublisherDropdown();
    updateCount();

    // Sync pill active state from URL — definitive source of truth regardless
    // of what Liquid server-side detection returned (fallback for Search &
    // Discovery not yet indexing a tag value).
    var urlTag = new URL(window.location.href).searchParams.get('filter.p.tag') || '';
    console.log('[CC] window.CC:', JSON.stringify(window.CC));
    console.log('[CC] URL filter.p.tag:', urlTag, '| CC.activeTag:', window.CC && window.CC.activeTag);
    document.querySelectorAll('.cc-type-pill').forEach(function (btn) {
      var shouldBeActive = urlTag ? btn.dataset.type === urlTag : btn.dataset.type === 'all';
      btn.classList.toggle('cc-type-pill--active', shouldBeActive);
    });

    document.querySelectorAll('.cc-type-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        handleTypePillClick(btn.dataset.type, btn);
      });
    });

    elPubSelect.addEventListener('change', function () {
      handlePublisherChange(this.value);
    });

    elSortSelect.addEventListener('change', function () {
      handleSortChange(this.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
